<template>
  <div class="menuBox">
    <div class="logo">
      <el-image :src='require("../../../static/img/logo.png")' fit="contain" class="img" @click="toindex"></el-image>
      <!-- <img src="../../../static/img/logo.png" alt="" class="img" @click="toindex"> -->
      </div>

    <div class="menuitemBox">
      <el-menu router :default-active="$route.path">
        <navigation-item v-for="(menu,i) in permission" :key="i" :item="menu"/>
      </el-menu>
    </div>
  </div>
</template>

<script>
  import navigationItem from "./navigation";
  export default {
      name: "index",
      inject:["reload"],
      components: {
        navigationItem
      },
      data () {
        return {
          user:this.$store.state.user,
          navList: [
            {
              icon: 'el-icon-s-home',
              name: '首页',
              href: '/index',
              roles: ['admin'],
            },
            {
              icon: 'el-icon-s-check',
              name: '进修生管理',
              href: 'student',
              roles: ['admin'],
              children: [
                {
                  name: '进修申请审核',
                  href: '/student/signup',
                  roles: ['admin'],
                  children:[
                    {
                      name: '医师医技',
                      href: '/student/signup/ys',
                      roles: ['admin']
                    }, {
                      name: '护理',
                      href: '/student/signup/hl',
                      roles: ['admin']
                    }
                  ]
                }, 
                {
                  name: '报道管理',
                  href: '/student/checkin',
                  roles: ['admin']
                }, {
                  name: '结业管理',
                  href: '/student/graduation',
                  roles: ['admin']
                }
              ]
            }, {
              icon: 'el-icon-s-data',
              name: '数据统计',
              href: 'data',
              roles: ['admin'],
              children: [
                {
                  name: '数据统计',
                  href: '/data/data',
                  roles: ['admin']
                }
              ]
            },
             {
              icon: 'el-icon-setting',
              name: '系统管理',
              href: 'admin',
              roles: ['admin'],
              children: [
                {
                  name: '字典管理',
                  href: '/admin/dictionaries',
                  roles: ['admin']
                }, {
                  name: '报名费用管理',
                  href: '/admin/fee',
                  roles: ['admin']
                }, {
                  name: '护理部费用管理',
                  href: '/admin/nursingFee',
                  roles: ['admin']
                }, {
                  name: '用户管理',
                  href: '/admin/user',
                  roles: ['admin']
                },{
                  name: '权限管理',
                  href: '/admin/role',
                  roles: ['admin']
                }
              ]
            },
          ],
          permission: this.$store.state.user.permission
        }
      },
      computed:{
        
      },
      watch: {
        
      },
      created(){  //载入前
        
      },
      methods:{  //业务
        //跳转首页
        toindex(){
          this.$router.push({
              path:'/index'
          })
        }
      }
  }
</script>

<style lang="scss" scoped>
  .menuBox{
    width: 240px;
    height: 100vh;
  }
  .logo{
    width: 240px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FBFBFB;
    border-bottom: 1px solid #ccc;
    .img{
      width: 80px;
      height: 80px;
      cursor: pointer;
    }
  }
  .menuitemBox{
    width: 240px;
    height: calc(100vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;
    border-right: 1px solid #FBFBFB;
  }

</style>



// WEBPACK FOOTER //
// src/components/menu/index.vue